module.exports = __webpack_public_path__ + "img/65_big-potato.1dc949ee.jpg";